// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.
export enum EquipmentStatusEnum {
  All = 'All',
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum SupportStatusEnum {
  All = 'All',
  Supported = 'Supported',
  Limited = 'Limited',
}
